import {intentTypes} from "./type";
import {BaseReducer} from "../../reducers/base";

const types = intentTypes;

const initialState = {
    datas: [],
    data: {},
    isLoading: false,
    success: false,
    msg: {},
};

const intentReducer = (state = initialState, action) => {
    const baseClass = new BaseReducer(types, state, action);

    return baseClass.baseReducer();
};

export default intentReducer;
